import React, { useState, useCallback, useEffect, useMemo } from 'react';
import { IView, Flexbox, LoadingProgress } from '@framework-controls/core';
import { JSXSwitch, JSXCase } from '@framework-controls/jsxconditions';
import css from './ServiceTab.module.scss';
import MaintenanceMenus from '../MaintenanceMenus/containers/MaintenanceMenus';
import WriteYourOwn from '../WriteYourOwn/containers/WriteYourOwn';
import IndividualServices from '../IndividualServices/containers/IndividualServices';
// import ErrorMessage from 'src/components/ErrorMessage/ErrorMessage';
import SkipLightBox from '../AddSkipServices/SkipLightBox/SkipLightBox';
import { Diagnoses } from '../WriteYourOwn/WriteYourOwn';
import { SpecData, UpdateApptOpsInp, UpdateApptDateInp, ApptCust, OpType, WebOp, WebOpChecked, ApptOps, DeteremineDeptInp, DepartmentSpec, invalidDates, VehicleRecs, Advisor, ascCtaInteractionInput, ascRetailProcessInput, ascPageviewInput, ascElementConfigurationInput } from 'src/models';
import { ComponentMapIds } from '../map';
import Footer from '../Footer/Footer';
import { IMenusState, IServicesState, IAppointmentState } from 'src/store/states';
import ServiceTabBtn from '../ServiceTab/ServiceTabBtn/ServiceTabBtn';
import { strings } from 'src/localization';
import { ViewMode } from 'src/enums';
import { BlankDeptSpec } from 'src/models/Specs/TestSpecs';
import { ascCtaInteraction, ascElementConfiguration, ascPageview, ascRetailProcess, getElementColor } from 'src/helpers/EventHelper/EventHelper';
import classNames from 'classnames';
import { sendSdEvent, getProviderId, buildApptData } from 'src/helpers/ShiftDigitalHelper/ShiftDigitalHelper';

export enum ButtonIds {
    MaintMenu = 'maintMenu',
    IndSvcs = 'indSvcs',
    WriteYour = 'writeYourOwn',
}

export interface IProps {
    appointment: IAppointmentState;
    specData?: SpecData;
    apptCust?: ApptCust;
    specProfile: string;
    webOps: WebOp[];
    webOpChecked: WebOpChecked[];
    maintMenus: IMenusState;
    apptOps: ApptOps[];
    additionalServices: IServicesState;
    specDefaultDept: string;
    specDeptData: DepartmentSpec;
    invalidDates: invalidDates[];
    invalidDatesDept: string;
    apptDept: string;
    theme: string;
    viewMode: ViewMode;
    selectedVehicle?: string;
    vehicles: VehicleRecs;
    apptAdvNum?: string;
    mainPaneViewOrder: IView[];
    locale: string;
    sessionId: string;
    lexusMCLaunched: string;
    toyotaMCLaunched: string;
    lexusTDMCLaunched: string;
    toyotaTDMCLaunched: string;
    pushToMainPanes: (inputView: IView) => void;
    UpdateApptOps: (inputOps: UpdateApptOpsInp[]) => void;
    getRMTimes: (specProfile: string) => void;
    getInvalidDates: (pecProfile: string) => void;
    determineDept: (inp: DeteremineDeptInp) => void;
    getDeptSpecs: () => void;
    clearInvalidDates: () => void;
    toggleOpsLangLits: (language: string) => void;
    updateApptDate: (inp: UpdateApptDateInp) => void;
}



const ServiceTab = (props: IProps) => {
    const btnMaintMenuLit = props.specData?.maintSchTabMsg ? props.specData?.maintSchTabMsg : '';
    const btnIndSvcsLit = props.specData?.indSVCsTabMsg ? props.specData?.indSVCsTabMsg : '';
    const btnWriteYourOwnLit = props.specData?.writeYourOwnTabMsg ? props.specData?.writeYourOwnTabMsg : '';
    const [btnSelected, setBtnSelected] = useState<string>();
    const [skipLit, setSkipLit] = useState<boolean>(props.apptOps.length > 0);
    const [disableFooter, setDisableFooter] = useState<boolean>(false);
    const [exitFlag, setExitFlag] = useState<boolean>(false);
    const [boxOpenFlag, setBoxOpenFlag] = useState(false);
    const [moveFlag, setMoveFlag] = useState('');
    const [tabArray, setTabArray] = useState<string[]>([]);
    const [prevDept, setPrevDept] = useState<string>(props.apptDept);
    const [editApptProceed, setEditApptProceed] = useState<boolean>(false);
    const [unenteredIssue, setUnenteredIssue] = useState<string>('');
    const [unenteredWarning, setUnenteredWarning] = useState<boolean>(false);
    const [unenteredDiagnosis, setUnenteredDiagnosis] = useState<boolean>(false);
    const [maintLength, setMaintLength] = useState(props.maintMenus.allMenus.menus.length);

    const isSDAnalyticsEnabled =
        props.specData?.toyotaTrackingFlag === 'Y' ||
        props.specData?.lexusTrackingFlag === 'Y' ||
        props.specData?.mbzTrackingFlag === 'Y' ||
        props.specData?.mazdaCATrackingFlag === 'Y' ||
        props.specData?.vwTrackingFlag === 'Y';

    useEffect(() => {
        if (props.specDeptData === BlankDeptSpec) {
            props.getDeptSpecs();
        }
        props.toggleOpsLangLits(props.locale);
    }, [props.specDeptData, props.getDeptSpecs, props.toggleOpsLangLits, props.locale]);

    // opens the skip services warning message
    const skipOpenHandler = useCallback(() => {
        setBoxOpenFlag(true);
    }, []);

    // closes the skip services warning message
    const skipCloseHandler = useCallback((e: any) => {
        setBoxOpenFlag(false);
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'service',
            elementText: strings.Cancel,
            elementColor: '',
            elementOrder: '',
            elementType: 'scheduling_tool',
            elementSubType: 'nav_button',
            eventAction: 'click',
            eventActionResult: 'close',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);
    }, [props.vehicles, props.selectedVehicle]);

    const recomTimes = useMemo (() => (
        {
            'S': props.specData?.svcSpecs?.recommTimes,
            'B': props.specData?.bdySpecs?.recommTimes,
            'Q': props.specData?.ossSpecs?.recommTimes,
        }
    ), [props.specData?.svcSpecs?.recommTimes,
        props.specData?.bdySpecs?.recommTimes,
        props.specData?.ossSpecs?.recommTimes]);

    const moveToNextTab = useCallback(() => {
        const current = tabArray.findIndex((element) => element === btnSelected);
        setBtnSelected(tabArray[current+1]);
    }, [tabArray, btnSelected]);

    const skipHandler = useCallback((e: any) => {
        if (unenteredIssue || unenteredDiagnosis) {
            setUnenteredWarning(true);
        }
        if (props.apptOps.length === 0) {
            if (props.specData?.skipServicesFlag) {
                if (btnSelected !== tabArray[tabArray.length-1]) {
                    setUnenteredWarning(false);
                    moveToNextTab();
                } else {
                    if (!(unenteredIssue || unenteredDiagnosis)) {
                        skipOpenHandler();
                    }
                }
            } else {
                if (btnSelected !== tabArray[tabArray.length-1]) {
                    moveToNextTab();
                }
            }
        }
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'service',
            elementText: skipLit ? strings.Skip : strings.Proceed,
            elementColor: '',
            elementOrder: '',
            elementType: 'scheduling_tool',
            elementSubType: 'nav_button',
            eventAction: 'click',
            eventActionResult: 'next_step',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);
        const ascElementConfigurationInp: ascElementConfigurationInput = {
            pageType: 'service',
            elementText: skipLit ? strings.Skip : strings.Proceed,
            elementType: 'scheduling_tool',
            elementColor: '',
            eventAction: 'click',
            eventActionResult: 'close',
            linkUrl: '',
        };
        ascElementConfiguration(ascElementConfigurationInp, e);
    }, [unenteredIssue, unenteredDiagnosis, props.apptOps.length, props.specData?.skipServicesFlag,
        btnSelected, tabArray, moveToNextTab, skipOpenHandler, skipLit, props.vehicles, props.selectedVehicle]);

    useEffect(() => {
        if (!props.specData?.skipServicesFlag) {
            if (btnSelected === tabArray[tabArray.length-1]) {
                setSkipLit(false);
                if (props.additionalServices.checkedWeOwes.length === 0 && props.additionalServices.checkedRecalls.length === 0 &&
                    props.additionalServices.checkedRecoms.length === 0 && props.maintMenus.checkedMileageMenu.length === 0 &&
                    props.maintMenus.checkedConditionalMenus.length === 0 && props.webOpChecked.length === 0 &&
                    props.apptOps.findIndex(op => op.opType === OpType.WriteYourOwn) === -1 &&
                    props.apptOps.findIndex(op => op.opType === OpType.Diagnosis) === -1 &&
                    (props.apptOps.findIndex(op => op.opType === OpType.ViewApptListService) === -1)) {
                    setDisableFooter(true);
                } else {
                    setDisableFooter(false);
                }
            } else {
                setDisableFooter(false);
                if (props.additionalServices.checkedWeOwes.length === 0 && props.additionalServices.checkedRecalls.length === 0 &&
                    props.additionalServices.checkedRecoms.length === 0 && props.maintMenus.checkedMileageMenu.length === 0 &&
                    props.maintMenus.checkedConditionalMenus.length === 0 && props.webOpChecked.length === 0 &&
                    props.apptOps.findIndex(op => op.opType === OpType.WriteYourOwn) === -1 &&
                    props.apptOps.findIndex(op => op.opType === OpType.Diagnosis) === -1 &&
                    (props.apptOps.findIndex(op => op.opType === OpType.ViewApptListService) === -1)) {
                    setSkipLit(true);
                } else {
                    setSkipLit(false);
                }
            }
        } else {
            if (props.additionalServices.checkedWeOwes.length === 0 && props.additionalServices.checkedRecalls.length === 0 &&
            props.additionalServices.checkedRecoms.length === 0 && props.maintMenus.checkedMileageMenu.length === 0 &&
            props.maintMenus.checkedConditionalMenus.length === 0 && props.webOpChecked.length === 0 &&
            props.apptOps.findIndex(op => op.opType === OpType.WriteYourOwn) === -1 &&
            props.apptOps.findIndex(op => op.opType === OpType.Diagnosis) === -1 &&
            (props.apptOps.findIndex(op => op.opType === OpType.ViewApptListService) === -1)) {
                setSkipLit(true);
            } else {
                setSkipLit(false);
                setDisableFooter(false);
            }
        }
    }, [props.specData?.skipServicesFlag,
        btnSelected,
        tabArray,
        props.additionalServices,
        props.maintMenus,
        props.webOpChecked,
        props.apptOps]);

    const skipProceed = (reason: string) => {
        // if (props.specData?.recommendedTimes && props.apptCust?.custFirstName !== '') {
        if (skipLit) {
            let apptOpsCopy: UpdateApptOpsInp[] = [...props.apptOps];
            // If the skipServiceReason already exists, delete it first
            const skipServiceIndex = apptOpsCopy.findIndex(op => op.opType === OpType.SkipServiceReason);
            if (skipServiceIndex !== -1) {
                apptOpsCopy.splice(skipServiceIndex, 1);
            }
            apptOpsCopy = [
                ...apptOpsCopy,
                {
                    id: 'skipReason',
                    operation: 'reason',
                    concern: reason,
                    estTime: '',
                    menuID: '',
                    spgOp: '',
                    opType: OpType.SkipServiceReason,
                    // department: 'S',
                    department: props.specDefaultDept,
                    itemCostLow: '****',
                    itemCostHigh: '****',
                    opWaiter: '',
                    opLoaner: '',
                    opRental: '',
                    opConcierge: '',
                    opCadillac: '',
                    opPPUDWL: '',
                },
            ];
            props.UpdateApptOps(apptOpsCopy);
            const defaultDept = props.specDefaultDept;
            const determineDept = {
                defaultDept: defaultDept,
            };
            props.determineDept(determineDept);
            props.getDeptSpecs();
            setExitFlag(false);
            // const quickType = props.specDeptData.recTimesCtgry;
            // let advName = props.selectedVehicle ? props.vehicles[props.selectedVehicle].lastAdvName : '';
            let advNumber = props.selectedVehicle ? props.vehicles[props.selectedVehicle].lastAdv : '';
            if (advNumber) {
                const advIndex = props.specDeptData.Advisors.findIndex(adv => adv.advisorNum === advNumber);
                if (advIndex === -1) {
                    // advName = '';
                    advNumber = '';
                }
            }
            let transLit = props.selectedVehicle ? props.vehicles[props.selectedVehicle].lastTransLit : '';
            const transType = props.selectedVehicle ? props.vehicles[props.selectedVehicle].lastTrans : '';
            if (transLit) {
                const transIndex = props.specDeptData.Transportation.findIndex(trans => trans.type === transType);
                if (transIndex === -1) {
                    transLit = '';
                }
            }
            // if (props.specData?.recommendedTimes && props.apptCust?.custFirstName !== '') {
            // if the department has changed and the current advisor is no longer valid we need to go to calandar select
            if (props.viewMode === ViewMode.EditAppt) {
                setEditApptProceed(true);
            } else {
                let skipQuickTimes = true;
                if (recomTimes[props.apptDept] === 'Y' && props.apptCust?.custFirstName !== '' &&
                    props.apptCust?.custNameId !== '') {
                    // if ((quickType === 'A' && advName !== '') || (quickType === 'T' && transLit !== '')) {
                    skipQuickTimes = false;
                    // }
                }
                if (skipQuickTimes) {
                    if (props.apptDept !== props.invalidDatesDept) {
                        props.pushToMainPanes({
                            viewId: ComponentMapIds.CalendarSelect,
                            component: ComponentMapIds.CalendarSelect,
                        });
                    }
                    setMoveFlag('T');
                } else {
                    props.pushToMainPanes({
                        viewId: ComponentMapIds.QuickTime,
                        component: ComponentMapIds.QuickTime,
                    });
                }
                const ascRetailProcessInp: ascRetailProcessInput = {
                    pageType: 'service',
                    flowStage: '4b',
                    flowOutcome: 'proceed',
                    flowName: 'appointment',
                    elementTitle: 'Skip Services',
                };
                ascRetailProcess(ascRetailProcessInp, props.vehicles, props.selectedVehicle);
            }
            if (isSDAnalyticsEnabled) {
                sendSdEvent('scheduleServiceSelectionFinish', buildApptData(props.sessionId,
                    getProviderId(props.specData, props.toyotaMCLaunched, props.toyotaTDMCLaunched,
                        props.lexusMCLaunched, props.lexusTDMCLaunched), props.appointment));
            }
        }
        setBoxOpenFlag(false);
    };

    useEffect(() => {
        let checkDate = '';
        if (props.invalidDates[0]) {
            checkDate = props.invalidDates[0].date;
        }
        if (moveFlag === 'T' && (checkDate === '00/00/00')) {
            setMoveFlag('');
            props.pushToMainPanes({
                viewId: ComponentMapIds.CalendarSelect,
                component: ComponentMapIds.CalendarSelect,
            });
        }
    }, [moveFlag, props.pushToMainPanes, props.invalidDates]);

    // Determine how many tabs we display to keep track for the skip/proceed button
    useEffect(() => {
        const setter: string[] = [];
        if (props.maintMenus.allMenus.menus && props.maintMenus.allMenus?.menus[0]) {
            setter.push(ButtonIds.MaintMenu);
        }
        if (props.webOps[0]) {
            setter.push(ButtonIds.IndSvcs);
        }
        if (props.specData?.showDiagnTool || props.specData?.showWrtYourOwn) {
            setter.push(ButtonIds.WriteYour);
        }
        setTabArray(setter);
    }, [props.maintMenus,
        props.webOps,
        props.specData?.showDiagnTool,
        props.specData?.showWrtYourOwn]);

    useEffect(() => {
        if (exitFlag && !skipLit) {
            setExitFlag(false);
            // const quickType = props.specDeptData.recTimesCtgry;
            // let advName = props.selectedVehicle ? props.vehicles[props.selectedVehicle].lastAdvName : '';
            let advNumber = props.selectedVehicle && props.selectedVehicle !== '-1' ?
                props.vehicles[props.selectedVehicle].lastAdv : '';
            if (advNumber) {
                const advIndex = props.specDeptData.Advisors.findIndex(adv => adv.advisorNum === advNumber);
                if (advIndex === -1) {
                    // advName = '';
                    advNumber = '';
                }
            }
            let transLit = props.selectedVehicle && props.selectedVehicle !== '-1' ?
                props.vehicles[props.selectedVehicle].lastTransLit : '';
            const transType = props.selectedVehicle && props.selectedVehicle !== '-1' ?
                props.vehicles[props.selectedVehicle].lastTrans : '';
            if (transLit) {
                const transIndex = props.specDeptData.Transportation.findIndex(trans => trans.type === transType);
                if (transIndex === -1) {
                    transLit = '';
                }
            }
            // if (props.specData?.recommendedTimes && props.apptCust?.custFirstName !== '') {
            // if the department has changed and the current advisor is no longer valid we need to go to calandar select
            if (props.viewMode === ViewMode.EditAppt) {
                setEditApptProceed(true);
            } else {
                // If recoommend Times is active in specs and we have a valid customer then we want to go to
                // the QuickSelect screen.  But we only want to go there if we have a lastAdv or lastTrans for
                // vehicle.  This is based on if specs indicates if recommended times is based on Adv or Trans
                let skipQuickTimes = true;
                if (recomTimes[props.apptDept] === 'Y' && props.apptCust?.custFirstName !== '' &&
                    props.apptCust?.custNameId !== '') {
                    // if ((quickType === 'A' && advName !== '') || (quickType === 'T' && transLit !== '')) {
                    skipQuickTimes = false;
                    // }
                }
                if (skipQuickTimes) {
                    if (props.apptDept !== props.invalidDatesDept) {
                        props.clearInvalidDates();
                        props.pushToMainPanes({
                            viewId: ComponentMapIds.CalendarSelect,
                            component: ComponentMapIds.CalendarSelect,
                        });
                    }
                    setMoveFlag('T');
                } else {
                    props.pushToMainPanes({
                        viewId: ComponentMapIds.QuickTime,
                        component: ComponentMapIds.QuickTime,
                    });
                }
                const ascRetailProcessInp: ascRetailProcessInput = {
                    pageType: 'service',
                    flowStage: '4a',
                    flowOutcome: 'added',
                    flowName: 'appointment',
                    elementTitle: 'Add Services',
                };
                ascRetailProcess(ascRetailProcessInp, props.vehicles, props.selectedVehicle);
            }
            if (isSDAnalyticsEnabled) {
                sendSdEvent('scheduleServiceSelectionFinish', buildApptData(props.sessionId,
                    getProviderId(props.specData, props.toyotaMCLaunched, props.toyotaTDMCLaunched,
                        props.lexusMCLaunched, props.lexusTDMCLaunched), props.appointment));
            }
        }
    }, [props.apptDept, props.invalidDatesDept, props.clearInvalidDates, props.getInvalidDates,
        props.specProfile, props.apptCust, props.pushToMainPanes, props.selectedVehicle, props.specDeptData,
        props.vehicles, props.viewMode, exitFlag, setExitFlag, skipLit, recomTimes, props.sessionId,
        props.specData, props.toyotaMCLaunched, props.toyotaTDMCLaunched, props.lexusMCLaunched, props.lexusTDMCLaunched,
        isSDAnalyticsEnabled, props.appointment]);

    // the point of this logic is to select the starting tab based on the data available
    // we do not want it to trigger on every render so we use the useEffect hook
    // and check if it is already set since the language toggle can change webOps
    useEffect(() => {
        if (btnSelected === '' || btnSelected === undefined) {
            if (props.maintMenus.allMenus.menus && props.maintMenus.allMenus.menus[0]) {
                setBtnSelected(ButtonIds.MaintMenu);
            } else {
                if (props.webOps[0]) {
                    setBtnSelected(ButtonIds.IndSvcs);
                } else {
                    setBtnSelected(ButtonIds.WriteYour);
                }
            }
        }
    }, [props.maintMenus.allMenus.menus, props.webOps, setBtnSelected, btnSelected]);

    const addWriteYourOwn = useCallback((diagnosis: Diagnoses) => {
        let writeYourOwnCount = 0;
        props.apptOps.forEach((apptOp) => {
            if (apptOp.opType === OpType.WriteYourOwn || apptOp.opType === OpType.Diagnosis) {
                writeYourOwnCount++;
            }
        });
        const apptOpsCopy: UpdateApptOpsInp[] = [
            ...props.apptOps,
            {
                id: 'diagnosis' + writeYourOwnCount,
                operation: diagnosis.opType === OpType.Diagnosis ? 'DIAG' : 'WYO',
                // operation: diagnosis.comment,
                concern: diagnosis.diagnosis + ' ' + diagnosis.comment,
                estTime: '',
                menuID: '',
                spgOp: '',
                opType: diagnosis.opType,
                // department: 'S',
                department: props.specDefaultDept,
                itemCostLow: '****',
                itemCostHigh: '****',
                opWaiter: '',
                opLoaner: '',
                opRental: '',
                opConcierge: '',
                opCadillac: '',
                opPPUDWL: '',
            },
        ];
        props.UpdateApptOps(apptOpsCopy);
        const defaultDept = props.specDefaultDept;
        const determineDept = {
            defaultDept: defaultDept,
        };
        props.determineDept(determineDept);
        props.getDeptSpecs();
    }, [props.UpdateApptOps, props.apptOps, props.determineDept, props.specDefaultDept, props.getDeptSpecs]);

    const removeWriteYourOwn = (id: string, e: any) => {
        // Filter out the removed id
        let apptOpsCopy = props.apptOps.filter((apptOp) => apptOp.id !== id);
        let writeYourOwnCount = 0;
        const elementColor = getElementColor(e, 'color');
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'service',
            elementText: 'x',
            elementColor: elementColor,
            elementOrder: '',
            elementType: 'scheduling_tool',
            elementSubType: 'other_buttons',
            eventAction: 'click',
            eventActionResult: 'close',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);
        const ascElementConfigurationInp: ascElementConfigurationInput = {
            pageType: 'service',
            elementText: 'x',
            elementType: 'scheduling_tool',
            elementColor: elementColor,
            eventAction: 'click',
            eventActionResult: 'close',
            linkUrl: '',
        };
        ascElementConfiguration(ascElementConfigurationInp, e);
        apptOpsCopy = apptOpsCopy.map((apptOp) => {
            let id = apptOp.id;
            // Rewrite the writeYourOwn ids
            if (apptOp.opType === OpType.WriteYourOwn || OpType.Diagnosis) {
                id = 'diagnosis' + writeYourOwnCount;
                writeYourOwnCount++;
            }
            // Use the spread operator so we aren't modifying the original

            return {...apptOp, id: id};
        });

        props.UpdateApptOps(apptOpsCopy);
        const defaultDept = props.specDefaultDept;
        const determineDept = {
            defaultDept: defaultDept,
        };
        props.determineDept(determineDept);
        props.getDeptSpecs();
    };

    const filteredWriteYourOwn = props.apptOps.filter((apptOp) => (
        apptOp.opType === OpType.WriteYourOwn || apptOp.opType === OpType.Diagnosis));
    const diagnoses: Diagnoses[] = [];
    filteredWriteYourOwn.forEach((writeYourOwn) => {
        diagnoses.push({
            id: writeYourOwn.id,
            comment: writeYourOwn.operation,
            diagnosis: writeYourOwn.concern,
            opType: writeYourOwn.opType,
        });
    });

    useEffect(() => {
        if (editApptProceed) {
            setEditApptProceed(false);
            // check if prevDept is equal to current dept
            if (prevDept===props.apptDept) {
                props.pushToMainPanes({
                    viewId: ComponentMapIds.CalendarSelect,
                    component: ComponentMapIds.CalendarSelect,
                });
            } else {
                // obtain varaiables needed for quicktime logic
                // const quickType = props.specDeptData.recTimesCtgry;
                // let advName = props.selectedVehicle ? props.vehicles[props.selectedVehicle].lastAdvName : '';
                let advNumber = props.selectedVehicle && props.selectedVehicle !== '-1' ?
                    props.vehicles[props.selectedVehicle].lastAdv : '';
                if (advNumber) {
                    const advIndex = props.specDeptData.Advisors.findIndex(adv => adv.advisorNum === advNumber);
                    if (advIndex === -1) {
                        // advName = '';
                        advNumber = '';
                    }
                }
                let transLit = props.selectedVehicle ? props.vehicles[props.selectedVehicle].lastTransLit : '';
                const transType = props.selectedVehicle ? props.vehicles[props.selectedVehicle].lastTrans : '';
                if (transLit) {
                    const transIndex = props.specDeptData.Transportation.findIndex(trans => trans.type === transType);
                    if (transIndex === -1) {
                        transLit = '';
                    }
                }
                // find the advisor in the deptSpecs advisor list
                let advFound = false;
                let apptDeptAdvisors: Advisor[] = [];
                switch (props.apptDept) {
                    case 'B':
                        apptDeptAdvisors = props.specData!.bdySpecs!.Advisors;
                        break;
                    case 'P':
                        apptDeptAdvisors = props.specData!.pdiSpecs!.Advisors;
                        break;
                    case 'Q':
                        apptDeptAdvisors = props.specData!.ossSpecs!.Advisors;
                        break;
                    default:
                        apptDeptAdvisors = props.specData!.svcSpecs!.Advisors;
                        break;
                }
                apptDeptAdvisors.forEach((advisor) => {
                    if (advisor.advisorNum === props.apptAdvNum) {
                        advFound = true;
                    }
                });
                if (advFound) {
                    props.pushToMainPanes({
                        viewId: ComponentMapIds.Summary,
                        component: ComponentMapIds.Summary,
                    });
                } else {
                    let skipQuickTimes = true;
                    if (recomTimes[props.apptDept] === 'Y' && props.apptCust?.custFirstName !== '' &&
                        props.apptCust?.custNameId !== '') {
                        // if ((quickType === 'A' && advName !== '') || (quickType === 'T' && transLit !== '')) {
                        skipQuickTimes = false;
                        // }
                    }
                    if (skipQuickTimes) {
                        if (props.apptDept !== props.invalidDatesDept) {
                            props.clearInvalidDates();
                            props.pushToMainPanes({
                                viewId: ComponentMapIds.CalendarSelect,
                                component: ComponentMapIds.CalendarSelect,
                            });
                        }
                        setMoveFlag('T');
                    } else {
                        props.pushToMainPanes({
                            viewId: ComponentMapIds.QuickTime,
                            component: ComponentMapIds.QuickTime,
                        });
                    }
                }
            }
            setPrevDept(props.apptDept);
        }
    }, [props.apptDept,
        props.pushToMainPanes,
        props.apptAdvNum,
        props.clearInvalidDates,
        props.getInvalidDates,
        props.invalidDatesDept,
        props.specProfile,
        props.apptCust,
        props.selectedVehicle,
        props.specDeptData,
        props.vehicles,
        props.specData,
        prevDept,
        editApptProceed,
        recomTimes]);

    const warningProceed = useCallback(() => {
        if (btnSelected !== tabArray[tabArray.length-1]) {
            moveToNextTab();
        } else {
            props.getDeptSpecs();
            setExitFlag(true);
        }
    }, [props.getDeptSpecs, btnSelected, tabArray, moveToNextTab]);

    const footerHandler = useCallback((e: any) => {
    // The Proceed button will go to the QuickTime screen if valid via Specs otherwise
    // go to the CalendarSelect screen.
        const inp: UpdateApptDateInp = {
            selDate: '',
            selTime: '',
            selAdv: '',
            selTrans: '',
            selAdvName: '',
            selAdvImage: '',
            selTransFlag: '',
            selApptNum: props.appointment.Appointment.apptNum ? props.appointment.Appointment.apptNum : '',
        };
        props.updateApptDate(inp);
        const apptOpsCopy: UpdateApptOpsInp[] = [...props.apptOps];
        // If the skipServiceReason exists, delete it
        const skipServiceIndex = apptOpsCopy.findIndex(op => op.opType === OpType.SkipServiceReason);
        if (skipServiceIndex !== -1) {
            apptOpsCopy.splice(skipServiceIndex, 1);
        }
        props.UpdateApptOps(apptOpsCopy);
        if (!unenteredWarning && (unenteredDiagnosis || unenteredIssue) &&
        (btnSelected === tabArray[tabArray.length-1])) {
            setUnenteredWarning(true);
        } else {
            if (btnSelected !== tabArray[tabArray.length-1]) {
                moveToNextTab();
            } else {
                props.getDeptSpecs();
                setExitFlag(true);
            }
        }
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'service',
            elementText: skipLit ? strings.Skip : strings.Proceed,
            elementColor: '',
            elementOrder: '',
            elementType: 'scheduling_tool',
            elementSubType: 'nav_button',
            eventAction: 'click',
            eventActionResult: 'next_step',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);
        const ascElementConfigurationInp: ascElementConfigurationInput = {
            pageType: 'service',
            elementText: skipLit ? strings.Skip : strings.Proceed,
            elementType: 'scheduling_tool',
            elementColor: '',
            eventAction: 'click',
            eventActionResult: 'next_step',
            linkUrl: '',
        };
        ascElementConfiguration(ascElementConfigurationInp, e);
    }, [
        unenteredIssue, unenteredWarning, unenteredDiagnosis, props.apptOps, skipLit,
        props.UpdateApptOps, props.getDeptSpecs, btnSelected, tabArray, moveToNextTab,
        props.vehicles, props.selectedVehicle, props.appointment, props.updateApptDate,
    ]);

    const selectSvcTabBtn = (btn: ButtonIds, e: any) => {
        setBtnSelected(btn);
        let elementText = '';
        switch (btn) {
            case ButtonIds.IndSvcs:
                elementText = btnIndSvcsLit;
                setMaintLength(0);
                break;
            case ButtonIds.MaintMenu:
                elementText = btnMaintMenuLit;
                setMaintLength(props.maintMenus.allMenus.menus.length);
                break;
            case ButtonIds.WriteYour:
                elementText = btnWriteYourOwnLit;
                setMaintLength(0);
                break;
            default:
                elementText = '';
        }
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'service',
            elementText: elementText,
            elementColor: '',
            elementOrder: '',
            elementType: 'scheduling_tool',
            elementSubType: 'nav_tab',
            eventAction: 'click',
            eventActionResult: 'next_step',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);
    };


    let haveMaintMenu = false;
    if (props.maintMenus.allMenus.menus) {
        if (props.maintMenus.allMenus.menus[0]) {
            haveMaintMenu = true;
        }
    }
    // const haveMaintMenu = props.maintMenus.allMenus?.menus[0] ?? '';
    // const haveWebOps = props.webOps[0] ?? '';
    let haveWebOps = false;
    if (props.webOps) {
        if (props.webOps[0]) {
            haveWebOps = true;
        }
    }

    useEffect(() => {
        const currentTab = props.mainPaneViewOrder[props.mainPaneViewOrder.length - 1].viewId;
        if (haveMaintMenu && btnSelected === ButtonIds.MaintMenu && currentTab === ComponentMapIds.ServiceTab) {
            const ascPageViewInp: ascPageviewInput = {
                pageType: 'service',
                errorCode: '',
                itemResults: maintLength.toString(),
            };
            ascPageview(ascPageViewInp, props.vehicles, props.selectedVehicle);
        }
    }, [haveMaintMenu, maintLength, props.vehicles, props.selectedVehicle, btnSelected, props.mainPaneViewOrder]);

    const tabDivClassNames = classNames(
        css.tabDiv,
        {
            [css.tabDivCadillac]: props.theme === 'cadillac',
        },
    );

    return (
        <div>
            <SkipLightBox
                cancel={skipCloseHandler}
                proceed={skipProceed}
                dialogOpen={boxOpenFlag}
                specSkipMsg={props.specData?.skipSVCMsg}
                theme={props.theme}
                selectedVehicle={props.selectedVehicle}
                vehicles={props.vehicles}
            />
            {/* The ErrorMessage will appear to confirm the user wants to Skip adding services. */}
            {/* {boxOpenFlag ? <ErrorMessage
                headerMsg=''
                errorMsg={props.specData?.skipSVCMsg ? props.specData?.skipSVCMsg : ''}
                primaryBtnMessage={strings.Continue}
                secondaryBtnMessage={strings.Cancel}
                primaryHandler={skipProceed}
                primaryArrow
                secondaryHandler={skipCloseHandler}
                closeHandler={skipCloseHandler}
            /> : null} */}
            {moveFlag ? <LoadingProgress cssClasses={{ spinner: css.progressColor }} size={100} /> : null}
            <div className={css.mainDiv}>
                <div className={tabDivClassNames}>
                    <Flexbox
                        container
                        spacing={0}
                        direction={'row'}
                        noMargin={false}
                        alignItems={'center'}
                        justify={'space-around'}
                    >
                        {/* {props.maintMenus.allMenus?.menus[0] ? */}
                        { haveMaintMenu ?
                            <ServiceTabBtn
                                id={ButtonIds.MaintMenu}
                                label={btnMaintMenuLit}
                                onClick={(e: any) => selectSvcTabBtn(ButtonIds.MaintMenu, e)}
                                selected={btnSelected === ButtonIds.MaintMenu}
                                theme={props.theme}
                            /> : null}
                        {/* {props.webOps[0] ? */}
                        { haveWebOps ?
                            <ServiceTabBtn
                                id={ButtonIds.IndSvcs}
                                label={btnIndSvcsLit}
                                onClick={(e: any) => selectSvcTabBtn(ButtonIds.IndSvcs, e)}
                                selected={btnSelected === ButtonIds.IndSvcs}
                                theme={props.theme}
                            /> : null}
                        {props.specData?.showDiagnTool || props.specData?.showWrtYourOwn ?
                            <ServiceTabBtn
                                id={ButtonIds.WriteYour}
                                label={btnWriteYourOwnLit}
                                onClick={(e: any) => selectSvcTabBtn(ButtonIds.WriteYour, e)}
                                selected={btnSelected === ButtonIds.WriteYour}
                                theme={props.theme}
                            /> : null}
                    </Flexbox>
                </div>
                <div className={css.tabPane}>
                    <JSXSwitch>
                        <JSXCase Condition={btnSelected === ButtonIds.MaintMenu}>
                            <MaintenanceMenus />
                        </JSXCase>
                        <JSXCase Condition={btnSelected === ButtonIds.IndSvcs}>
                            <IndividualServices tabSwitch={setBtnSelected} />
                        </JSXCase>
                        <JSXCase Condition={btnSelected === ButtonIds.WriteYour}>
                            <WriteYourOwn
                                diagnoses={diagnoses}
                                addDiagnosis={addWriteYourOwn}
                                removeDiagnosis={removeWriteYourOwn}
                                unenteredIssue={unenteredIssue}
                                unenteredDiagnosis={unenteredDiagnosis}
                                setUnenteredIssue={setUnenteredIssue}
                                setUnenteredDiagnosis={setUnenteredDiagnosis}
                                unenteredWarning={unenteredWarning}
                                setUnenteredWarning={setUnenteredWarning}
                                warningProceed={warningProceed}
                                boxOpenFlag={boxOpenFlag}
                                setBoxOpenFlag={setBoxOpenFlag}
                            />
                        </JSXCase>
                    </JSXSwitch>
                </div>
            </div>
            {/* Will proceed if the user has services in cart otherwise it will display a warning message
                about skipping. */}
            {disableFooter ? <div className={css.proceedWarn}>{strings.PleaseSelectService}</div>:null}
            <Footer
                id='SvcTabFooter'
                handler={skipLit ? skipHandler : footerHandler}
                message={skipLit ? strings.Skip : strings.Proceed}
                isDisabled={disableFooter}
                secondaryhandler={footerHandler}
                theme={props.theme}/>
        </div>
    );
};
export default ServiceTab;